import type { UI } from '@/v2/types';
import { useEffect } from 'react';
import { Box } from '@qga/roo-ui/components';

import { Container } from '@/v2/components/layout/Container';
import { Layout } from '@/v2/components/layout/Layout';
import { Divider } from '@/v2/components/ui/Divider';
import usePageViewEvent from '@/v2/hooks/usePageViewEvent';
import contactUsMD from '@/v2/markdown/contactUs.md';
import Markdown from '../../../../components/ConditionsMarkdown';
import CallUs from '../../../../components/ContactUsPage/components/CallUs';
import LiveChat from '../../../../components/ContactUsPage/components/LiveChat';
import SendMessage from '../../../../components/ContactUsPage/components/SendMessage';
import Heading from '../../../../components/Heading';
import Link from '../../../../components/Link';
import Text from '../../../../components/Text';
// Legacy components
import { CallCentreWorkingStatusProvider } from '../../../../hooks/useCallCentreWorkingStatus';
import getFeatureFlag from '../../../../utils/getFeatureFlag';
import { dataLayer } from './utils/dataLayer';

// Note: Layout called here temporarily with props
// - needs to go to _app when v2 is complete

interface Props {
  importantInformation: Array<UI.ImportantInformation>;
  navigation: Array<UI.Navigation>;
  warningMessage: UI.Message | null;
  informationMessage: UI.Message | null;
  marketingMessage: UI.MarketingMessage | null;
}

const ContactUsView = (props: Props) => {
  useEffect(() => {
    dataLayer();
  }, []);

  usePageViewEvent({ type: 'contact_us' });

  return (
    <CallCentreWorkingStatusProvider>
      <Layout {...props}>
        <Container>
          <Box
            width={[null, null, '695px']}
            minHeight="calc(100vh - 245px)"
            pl={[null, null, 4]}
            py={[4, null, 8]}
          >
            <Heading.h1 fontSize={['md', null, '2xl']}>
              Contact the Jetstar Holidays team
            </Heading.h1>
            <Box mt="4">
              <Markdown markdown={contactUsMD} paragraphMarginBottom={0} />
            </Box>
            <Box mt={[8, null, 10]}>
              <CallUs />
            </Box>
            {getFeatureFlag('WEB_CHAT') && (
              <>
                <Divider my={[5, null, 6]} />
                <LiveChat />
              </>
            )}
            {getFeatureFlag('CONTACT_FORM') && (
              <>
                <Divider my={[5, null, 6]} />
                <SendMessage />
              </>
            )}
            <Box mt="8">
              <Text>
                For further information please refer to our{' '}
                <Link.Text
                  as={null}
                  external={false}
                  shallow={false}
                  href="https://www.jetstar.com/au/en/holidays/faq"
                >
                  frequently asked questions.
                </Link.Text>
              </Text>
            </Box>
          </Box>
        </Container>
      </Layout>
    </CallCentreWorkingStatusProvider>
  );
};

export default ContactUsView;
